export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

/** JSON fetch against /api. POSTs always send a body (Fastify rejects empty JSON bodies). */
export async function api<T>(path: string, opts: { method?: string; body?: unknown } = {}): Promise<T> {
  const method = opts.method ?? (opts.body !== undefined ? "POST" : "GET");
  const body = method === "GET" ? undefined : JSON.stringify(opts.body ?? {});
  let r: Response;
  try {
    r = await fetch("/api" + path, { method, body, credentials: "same-origin", headers: body ? { "Content-Type": "application/json" } : {} });
  } catch {
    throw new ApiError(0, "offline", "Can't reach the server. Check your connection.");
  }
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new ApiError(r.status, data.error ?? "error", data.message ?? "Something went wrong.");
  return data as T;
}
